var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('button',{staticClass:"btn btn-green",on:{"click":_vm.abrirModal}},[_vm._v("Abrir")]),_c('modal-formulario',{ref:"modalAgendaPersonal"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }